import { gql, useLazyQuery } from "@apollo/client";
import React, { useState, useCallback } from "react";
import { usePicklists } from "ticketing/contexts/picklists/PicklistContextProvider";
import { GqlResponse, TCounterParty } from "ticketing/ticketing.types";

// for type ahead
export const GQL = gql`
  query partiesFilterBy($enterpriseSystemId: Int!, $name: String!) {
    counterparties: partiesFilterBy(
      filter: { enterpriseSystemId: $enterpriseSystemId, name: { regexIgnoreCase: $name }, external: { eq: true } }
    ) {
      id
      name
    }
  }
`;

const delay = 500;
type Response = GqlResponse<TCounterParty[], "counterparties">;

const useSearchCounterParties = () => {
  const { picklists } = usePicklists();
  const [searchResults, setSearchResults] = useState<TCounterParty[]>([]);

  const [filter, { loading, error }] = useLazyQuery<Response>(GQL, {
    errorPolicy: "all",
    fetchPolicy: "no-cache",
    onCompleted: (data) => setSearchResults(data.counterparties),
  });

  const timeout = React.useRef<ReturnType<typeof setTimeout> | null>(null);

  const search = (name: string) => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {
      filter({ variables: { enterpriseSystemId: picklists?.enterpriseSystemId, name: `%${name}%` } });
    }, delay);
  };
  const clear = useCallback(() => {
    setSearchResults([]);
  }, [setSearchResults]);
  return [search, searchResults, loading, error, clear] as const;
};

export default useSearchCounterParties;
